import { i18n } from "@lib/i18n";

export const transformVehicleDataToTestDrivePoint = ({
  id,
  _id,
  geoLatitude,
  geoLongitude,
  country,
  code,
}) => ({
  language: i18n.language,
  geoLatitude: String(geoLatitude),
  geoLongitude: String(geoLongitude),
  country,
  code,
  id,
  _id,
});
